var map = {
	"./example_config": 2555,
	"./example_config.json": 2555,
	"./introductiemodule": 6498,
	"./introductiemodule.json": 6498,
	"./module1": 873,
	"./module1.json": 873,
	"./module2": 4860,
	"./module2.json": 4860,
	"./module3": 4751,
	"./module3.json": 4751,
	"./vaardigheden": 7602,
	"./vaardigheden.json": 7602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1089;